// extracted by mini-css-extract-plugin
export default {"cardRow":"dashboard_cardRow__eZJSl","cardCell":"dashboard_cardCell__XkPk1"};